// css file
import 'swiper/css/bundle';
import '../sass/style.scss';

// >qte scripts
import './cart';
import './checkout';
import './disableAddToCartBtn';
import './faqPage';
import './hideAddedToCart';
import './howItWorksModule';
import './multiFileUpload';
import './productArchiveSearch';
import './pageArchiveSearch';
import './search';
import './sliderReview';
import './toggleFastProcessing';
import './toggleModule';
import './orderReceived';

const bootstrap = (window.bootstrap = require('bootstrap'));

(() => {
  // @todo uncomment when Swiper is available
  //if swiper is defined
  /*if (typeof Swiper === 'undefined') {
    console.error('Swiper not found');
    return;
  }

  const productsSlider = new Swiper('.products-slider .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    initialSlide: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const logos = new Swiper('.logoSwiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    initialSlide: 1,
    loop: true,
    autoplay: true,
    breakpoints: {
      768: {
        slidesPerView: 2.65,
      },
      320: {
        slidesPerView: 1.65,
      },
    },
  });
*/})();

let navLinks = document.querySelectorAll('.nav-item.submenus .nav-link');
if (navLinks.length > 0) {
  navLinks.forEach(function (item) {
    item.addEventListener('click', function (event) {
      const thisItem = this;
      thisItem.classList.toggle('submenu-open');
      let subMenu = thisItem.nextElementSibling;
      if (subMenu.classList.contains('d-block')) {
        subMenu.classList.remove('d-block');
      }

      //Open menu when clicking on the parent text/item
      thisItem.parentElement.nextElementSibling.classList.toggle('d-block');
    });
  });
}

let mobileNavLink = document.querySelectorAll(
  '.mobile-menu .nav-item.submenus .dropdown-arrow',
);
if (mobileNavLink.length > 0) {
  mobileNavLink.forEach(function (item) {
    item.addEventListener('click', function (event) {
      const currentItem = this;
      const currentItemSubMenu =
        currentItem.parentElement.parentElement.querySelector('.dropdown-menu');

      if (currentItemSubMenu.classList.contains('d-block')) {
        currentItemSubMenu.classList.remove('d-block');
      } else {
        let allSubmenus = document.querySelectorAll(
          '.mobile-menu .dropdown-menu',
        );
        allSubmenus.forEach(function (item) {
          item.classList.remove('d-block');
        });
        currentItemSubMenu.classList.add('d-block');
      }
    });
  });
}

let toggler = document.querySelector('.navbar-toggler span');
if (toggler) {
  toggler.addEventListener('click', function () {
    let header = document.querySelector('.header');
    let mobileMenu = document.querySelector('.mobile-menu');
    let body = document.querySelector('body');

    header.classList.toggle('header-smo');
    if (header.classList.contains('header-smo')) {
      toggler.innerHTML = 'Close';
      mobileMenu.classList.remove('d-none');
      mobileMenu.classList.add('d-flex');
      body.style.overflow = 'hidden';
    } else {
      toggler.innerHTML = 'Menu';
      mobileMenu.classList.add('d-none');
      mobileMenu.classList.remove('d-flex');
      body.style.overflow = 'auto';
    }
  });
}

const video = document.getElementById('video');
const circlePlayButton = document.getElementById('circle-play-b');

function togglePlay() {
  if (video.paused || video.ended) {
    video.play();
  } else {
    video.pause();
  }
}

if (circlePlayButton) {
  circlePlayButton.addEventListener('click', togglePlay);
}
if (video) {
  video.addEventListener('playing', function () {
    circlePlayButton.style.opacity = 0;
  });
  video.addEventListener('pause', function () {
    circlePlayButton.style.opacity = 1;
  });
}
